import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { DividendFilter } from 'src/pages/finSystem/balanceSummary/reports/reportDividends/types'

dayjs.extend(isoWeek)

const format = 'YYYY-MM-DD'
const now = dayjs()

type PeriodValue = {
  dateFrom: string
  dateTo: string
}

export const normalizeDate = (date: string | Date) => dayjs(date).format(format)

const getQuarterRange = (date: dayjs.Dayjs) => {
  const month = date.month()
  const startMonth = Math.floor(month / 3) * 3

  const start = date.month(startMonth).startOf('month')
  const end = start.add(2, 'month').endOf('month')

  return { start, end }
}

export const periodMap: Record<string, PeriodValue> = {
  this_week: {
    dateFrom: now.startOf('isoWeek').format(format),
    dateTo: now.endOf('isoWeek').isAfter(now)
      ? now.format(format)
      : now.endOf('isoWeek').format(format),
  },

  this_month: {
    dateFrom: now.startOf('month').format(format),
    dateTo: now.endOf('month').isAfter(now)
      ? now.format(format)
      : now.endOf('month').format(format),
  },

  this_quarter: (() => {
    const q = getQuarterRange(now)
    return {
      dateFrom: q.start.format(format),
      dateTo: q.end.isAfter(now) ? now.format(format) : q.end.format(format),
    }
  })(),

  last_week: {
    dateFrom: now.subtract(1, 'week').startOf('isoWeek').format(format),
    dateTo: now.subtract(1, 'week').endOf('isoWeek').format(format),
  },

  last_month: {
    dateFrom: now.subtract(1, 'month').startOf('month').format(format),
    dateTo: now.subtract(1, 'month').endOf('month').format(format),
  },

  last_quarter: (() => {
    const q = getQuarterRange(now.subtract(3, 'month'))
    return {
      dateFrom: q.start.format(format),
      dateTo: q.end.format(format),
    }
  })(),
}

export const getPeriodByRange = (
  dateFrom: string | null | undefined,
  dateTo: string | null | undefined,
): string | undefined => {
  if (!dateFrom || !dateTo) return undefined

  for (const [key, value] of Object.entries(periodMap)) {
    if (
      value.dateFrom === normalizeDate(dateFrom) &&
      value.dateTo === normalizeDate(dateTo)
    ) {
      return key
    }
  }

  return 'date_range'
}

export const filterOption = (
  inputValue: string,
  option?: { label?: string },
) => {
  if (!option?.label) return false
  return (
    option.label.toLowerCase().includes(inputValue.trim().toLowerCase()) ??
    false
  )
}

export const normalizeObject = (filters: DividendFilter) => {
  if (Object.keys(filters).length === 0) return
  const arrayFields = ['walletIds', 'currencies']

  return Object.fromEntries(
    Object.entries(filters).filter(([key, value]) =>
      arrayFields.includes(key)
        ? Array.isArray(value) && value.length > 0
        : Boolean(value),
    ),
  )
}
